import { useQueryClient } from '@tanstack/react-query';
import { authLogout } from './api';
import { useAuthStore, broadcastSignedOut } from './authStore';

// Full sign-out: end the session AND revoke this device, so the next visit
// requires a fresh Microsoft sign-in (+ passkey enrollment). Drops cached data
// and flips the gate to the Entra screen. Also notifies other tabs.
export function useLogout(): () => Promise<void> {
  const queryClient = useQueryClient();
  return async () => {
    try {
      await authLogout(true);
    } finally {
      broadcastSignedOut();
      useAuthStore.getState().signedOut();
      queryClient.clear();
    }
  };
}
